/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit ButtonTab.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-400.js"
import React from 'react'
import useIsHovered from 'Logic/useIsHovered.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  cursor: "pointer",
paddingTop: 8,
paddingBottom: 8,
paddingLeft: 16,
paddingRight: 16,
borderBottomLeftRadius: 5,
borderBottomRightRadius: 5,
borderStyle: "solid",
borderTopLeftRadius: 5,
borderTopRightRadius: 5,
borderWidth: 1,
userSelect: "none",
  
transition: 'background-color 150ms ease-in-out, border-color 150ms ease-in-out',
willChange: 'background-color, border-color',
  marginTop: 'var(--marginTop)',
marginRight: 'var(--marginRight)',
backgroundColor: 'var(--backgroundColor)',
borderColor: 'var(--borderColor)'})
styles.Text = css({label: 'Text',
  fontFamily: "WonderUnitSans",
fontSize: 14,
letterSpacing: 0.5,
fontWeight: 400,
  
transition: 'color 150ms ease-in-out',
willChange: 'color',
  color: 'var(--color)'})

export default function ButtonTab({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  onClick,
goTo,
marginTop= 0,
marginRight= 0,
isSelected,
text= "Deafult text"
}) {
    
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
    
    
    
    

  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
 data-testid="ButtonTab.Vertical"
 data-view-path={dataViewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--backgroundColor': isSelected ? "rgba(0,207,104, 0.1)" : isHovered ? "rgba(0,207,104, 0.15)" : "transparent",'--borderColor': isSelected ? "rgba(0,207,104, 0.2)" : isHovered ? "rgba(0,207,104, 0.0)" : "transparent"}}
 className={`views-block ${styles.Vertical}`}
>
<span
 data-testid="ButtonTab.Text"
 data-view-path={dataViewPath}
 style={{'--color': isSelected ? "rgba(0,188,112, 1)" : isHovered ? "rgba(0,188,112, 1)" : "#303030"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</a>
{children}
</React.Fragment>)
}